import { EventParams } from "../MathFactsGenerator/worksheetEventParams.ts";
import { Level, gradeOf } from "./equalGroups.ts";

/*
 * Equal Groups reports when a board ends, through the quiz's `quiz_completed`
 * event (ADR 0127 §7), so it needs no new GA4 registrations: `correct` is the
 * groups found and `wrong` the mistakes made. The grade ("grade_2" to "grade_8") stands in `operation`
 * and `mode` says daily or practice. Which tiles were chosen is not sent.
 */
export function dailyPuzzleEventParams(
    level: Level,
    daily: boolean,
    groupsFound: number,
    mistakes: number
): EventParams {
    return {
        operation: `grade_${gradeOf(level)}`,
        mode: daily ? "daily_puzzle" : "practice_puzzle",
        correct: groupsFound,
        wrong: mistakes,
        skipped: 0,
    };
}
